import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/cphi-frankfurt-2025")({
  head: () => buildRouteHead("/cphi-frankfurt-2025", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/events", replace: true });
  },
});
